import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

@Component({
    selector: 'app-question-textbox-amount',
    templateUrl: './question-textbox-amount.component.html',
    styleUrls: ['./question-textbox-amount.component.scss'],
    standalone: false
})
export class QuestionTextboxAmountComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() showDelete = false;
  @Output() questionAnswer = new EventEmitter<any>();

  maskOptions: NgxCurrencyConfig;
  value = '';
  description = '';
  uniqueDescriptionControlName = `textbox-amount-description-${newGuid()}`;
  uniqueDescriptionId = `textbox-amount-description-${newGuid()}`;
  uniqueValueControlName = `textbox-amount-value-${newGuid()}`;
  uniqueValueId = `textbox-amount-value-${newGuid()}`;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.value = '';
    this.description = '';
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.description = this.question?.answer.split('|')[0];
        this.value = this.question?.answer.split('|')[1];
      }
    }
    if (changes?.showDelete?.currentValue) {
      this.showDelete = changes?.showDelete?.currentValue;
    }
  }

  onChange(): void {
    const answer = (this.value && this.description) ? this.description + '|' + this.value.toString() : '';
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }
}
